import { useRef, useCallback } from "react"
import { useRecoilState, useSetRecoilState } from "recoil"
import {
  bottomMostUnreadAtom,
  chatIsReadAtom,
  topMostUnreadAtom
} from "../../recoil/atoms/chats"

type NotifyNewChatMessageSelectorProps = {
  id: number
  parentId: number
  isRead?: boolean
}

const useChatNotification = () => {
  const setChatIsRead = useSetRecoilState(chatIsReadAtom)
  const [topMostUnread, setTopMostUnread] = useRecoilState(topMostUnreadAtom)
  const [bottomMostUnread, setBottomMostUnread] =
    useRecoilState(bottomMostUnreadAtom)

  const topMostUnreadRef = useRef(null)
  const bottomMostUnreadRef = useRef(null)
  topMostUnreadRef.current = topMostUnread
  bottomMostUnreadRef.current = bottomMostUnread

  // const readAllChat

  const setBottomMostMessage = useCallback(
    (payload: NotifyNewChatMessageSelectorProps) => {
      if (!payload) {
        setBottomMostUnread(null)
        if (!topMostUnreadRef.current) {
          setChatIsRead(true)
        } else {
          setChatIsRead(false)
        }
        return
      }

      const { id, isRead = false, parentId } = payload
      setChatIsRead(isRead)
      setBottomMostUnread({ id, parentId, type: "Reply" })
    },
    [setChatIsRead, setBottomMostUnread]
  )

  const setTopMostMessage = useCallback(
    (payload?: NotifyNewChatMessageSelectorProps) => {
      if (!payload) {
        setTopMostUnread(null)
        if (!bottomMostUnreadRef.current) {
          setChatIsRead(true)
        } else {
          setChatIsRead(false)
        }
        return
      }
      const { id, isRead = false, parentId } = payload
      setChatIsRead(isRead)
      setTopMostUnread({ id, parentId, type: "Reply" })
    },
    [setChatIsRead, setTopMostUnread]
  )

  const setNewChatMessage = useCallback(
    (isRead: boolean = false) => {
      setChatIsRead(isRead)
      setBottomMostUnread({ id: 0, parentId: -1, type: "Message" })
    },
    [setChatIsRead, setBottomMostUnread]
  )

  return {
    setBottomMostMessage,
    setTopMostMessage,
    setNewChatMessage,
    bottomMostUnreadRef,
    topMostUnreadRef
  }
}

export default useChatNotification
